<template>
    <main>
        <header class="py-5 mb-2 mb-lg-5">
            <div class="container">
                <div class="row flex-column flex-lg-row justify-content-lg-between align-items-center">
                    <nav class="d-flex justify-content-center justify-content-lg-start p-0 mb-4 mb-lg-0">
                        <a href="#">Impact</a>
                        <a href="#">Connection</a>
                        <a href="#">Investment</a>
                    </nav>

                    <a href="mailto:connect@lioraproductions.eu" class="connect">Connect Here</a>
                </div>
            </div>
        </header>

        <div class="container">
            <div class="row align-items-center justify-content-between mb-5">
                <div class="col-12 col-lg-6 col-logo">
                    <img src="~@/assets/images/logo-liora-global.png" alt="Liora Global" class="d-block mx-auto mb-5 logo">
                    <p class="text-center mb-5">A catalyst for change through immersive activations and 360-degree strategies that merge culture, capital and conciousness.</p>
                    <h2 class="text-center mb-5 mb-lg-0">Website Loading soon...</h2>
                </div>

                <div class="col-12 col-lg-6 col-xl-5 col-contacts d-flex flex-column">
                    <a href="https://www.instagram.com/liora_global/" target="_blank" class="d-flex align-items-center instagram">
                        <span>/liora_global</span>
                    </a>

                    <a href="https://www.linkedin.com/company/liora-global/" target="_blank" class="d-flex align-items-center linkedin">
                        <span>/company/liora-global</span>
                    </a>

                    <a href="mailto:connect@lioraproductions.eu" class="d-flex align-items-center email">
                        <small>connect@lioraproductions.eu</small>
                    </a>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    export default {
        name: 'WorkInProgress',
    }
</script>